"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var UkMoneyProtectionLined = function UkMoneyProtectionLined(_ref) {
  var className = _ref.className,
      style = _ref.style,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "style"]);

  var styleProp = Object.assign({
    verticalAlign: 'middle'
  }, style);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _classnames["default"])(className),
    viewBox: "0 0 24 24",
    style: styleProp
  }, otherProps), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.544 5c-4.033-.361-6.718-1.207-9.265-2.917a.5.5 0 00-.558 0A18.719 18.719 0 012.456 5 .5.5 0 002 5.523c.35 7.437 2.15 13.077 9.8 16.435a.5.5 0 00.4 0c7.7-3.4 9.485-9.027 9.8-16.436A.5.5 0 0021.544 5zM12 20.953c-6.04-2.716-8.508-6.83-8.976-15A19.336 19.336 0 0012 3.1a19.333 19.333 0 008.978 2.854C20.55 14.092 18.082 18.2 12 20.953zM12.688 6a2.684 2.684 0 012.059.961.5.5 0 01-.767.643A1.687 1.687 0 0011 8.688V11h2.475a.5.5 0 010 1H11v1.374A4.347 4.347 0 0110.274 16H14.5a.5.5 0 010 1h-6a.5.5 0 010-1c.417 0 1.5-.472 1.5-2.625V12h-.75a.5.5 0 010-1H10V8.688A2.691 2.691 0 0112.688 6z",
    fill: "currentColor"
  })));
};

var _default = UkMoneyProtectionLined;
exports["default"] = _default;